import styles from './PoweredBy.module.css';
export const PoweredBy = () => {
  return (
    <div className={styles.container}>
      <span>Powered by QuestionPro</span>
    </div>
  );
};
